export default __webpack_public_path__ + "media/images/artisan-c5ed4021f48c0ff630a58321c9430bca.png";